<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 4.5C15 5.88071 13.8807 7 12.5 7C11.1193 7 10 5.88071 10 4.5C10 3.11929 11.1193 2 12.5 2C13.8807 2 15 3.11929 15 4.5ZM15 12.5C15 13.8807 13.8807 15 12.5 15C11.1193 15 10 13.8807 10 12.5C10 11.1193 11.1193 10 12.5 10C13.8807 10 15 11.1193 15 12.5ZM12.5 23C13.8807 23 15 21.8807 15 20.5C15 19.1193 13.8807 18 12.5 18C11.1193 18 10 19.1193 10 20.5C10 21.8807 11.1193 23 12.5 23Z"
      fill="currentColor"
    />
  </svg>
</template>
